import { Injectable } from '@angular/core';
import { AccueilNavService } from './accueil-nav.service';
import { ArticlesNavService } from './articles-nav-service';
import { AvoirsNavService } from './avoirs-nav.service';
import { DossiersFinancementNavService } from './dossiers-financement-nav.service';
import { EntitesNavService } from './entites-nav.service';
import { EntreprisesNavService } from './entreprises-nav-service';
import { EvaluationsNavService } from "./evaluations-nav.service";
import { FacturesNavService } from './factures-nav.service';
import { FormateursNavService } from './formateurs-nav.service';
import { FormationsNavService } from './formations-nav-service';
import { InscriptionsNavService } from './inscriptions-nav.service';
import { InscriptionsParcoursNavService } from './inscriptions-parcours-nav.service';
import { ParcoursNavService } from './parcours-nav.service';
import { PersonnelsNavService } from './personnels-nav-service';
import { PersonnesNavService } from './personnes-nav.service';
import { ProfilsDroitsNavService } from './profils-droits-nav.service';
import { PublipostageModelesNavService } from './publipostage-modeles-nav-service';
import { RessourcesNavService } from "./ressources-nav.service";
import { RootNavService } from './root-nav.service';
import { SeancesNavService } from './seances-nav-service';
import { SessionsNavService } from './sessions-nav-service';
import { UtilisateursNavService } from './utilisateurs-nav.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    public root: RootNavService,
    public accueil: AccueilNavService,
    public sessions: SessionsNavService,
    public inscriptions: InscriptionsNavService,
    public inscriptionsParcours: InscriptionsParcoursNavService,
    public formations: FormationsNavService,
    public formateurs: FormateursNavService,
    public factures: FacturesNavService,
    public avoirs: AvoirsNavService,
    public entites: EntitesNavService,
    public utilisateurs: UtilisateursNavService,
    public personnes: PersonnesNavService,
    public profilsDroits: ProfilsDroitsNavService,
    public seances: SeancesNavService,
    public entreprises: EntreprisesNavService,
    public personnels: PersonnelsNavService,
    public articles: ArticlesNavService,
    public dossiersFinancement: DossiersFinancementNavService,
    public publipostageModeles: PublipostageModelesNavService,
    public evaluations: EvaluationsNavService,
    public ressources: RessourcesNavService,
    public parcours: ParcoursNavService
  ) {}
}
